// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { cartLinesListHeaderStyles } from "@bg/Overrides/Components/CartLinesListHeader";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

cartLinesListHeaderStyles.saveOrderLink = {
    ...linkIconStyleGenerator({
        icon: "SystemUpdate",
        textSize: `${fontConfig.fontSize.regular}px`,
        iconSize: 12,
    }),
    css: css`
        align-items: baseline;
        ${IconWrapper} {
            display: block;
            top: 1px;
            position: relative;
        }

        span {
            line-height: ${fontConfig.lineHeight.singleLine};
            font-weight: ${fontConfig.weight.semiBold};
            &:last-child {
                opacity: 0.8;
            }
        }
    `,
};

cartLinesListHeaderStyles.addAllToListLink = {
    ...linkIconStyleGenerator({
        icon: "AddToList",
        textSize: `${fontConfig.fontSize.regular}px`,
        iconSize: 12,
    }),
    css: css`
        margin-left: auto;
        align-items: baseline;

        ${IconWrapper} {
            display: block;
            top: 1px;
            position: relative;
        }
        span {
            line-height: ${fontConfig.lineHeight.singleLine};
            font-weight: ${fontConfig.weight.semiBold};
            &:last-child {
                opacity: 0.8;
            }
        }
        ${xScreen("lte", 500)} {
            margin-left: 0;
        }
    `,
};

cartLinesListHeaderStyles.cartLink = {
    typographyProps: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.singleLine,
        weight: fontConfig.weight.semiBold,
    },
};

cartLinesListHeaderStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex: 1;
        gap: 16px;
        margin-left: 24px;
        align-items: end;
    `,
};
